import ExportConfirmationModal from 'src/pages/accueil/export-page/ExportConfirmationModal ';
import { Route } from '../../../security/route';
import MentionsLegalesPage from '../../mentions-legales/mentions-legales-page';
import CreateProjectPage from '../project-page/create-project/create-project-page';
import DetailProjectPage from '../project-page/detail-project/detail-project-page';
import EditProjectPage from '../project-page/edit-project/edit-project-page';
import ListProjectPage from '../project-page/list-Project/list-project-page';
import ListActivityPage from '../setting/activities/activity/list-activity/list-activity';
import ProductionCycleDetail from '../setting/activities/production-cycle/ProductionCycleDetail';
import ProductionCycleEdit from '../setting/activities/production-cycle/ProductionCycleEdit';
import ProductionCyclePage from '../setting/activities/production-cycle/ProductionCyclePage';
import ListProductionPage from '../setting/activities/production/list-production/list-production';
import ListSousActivity from '../setting/activities/sous-activité/list-sous-activity/list-sous-activity';
import CurrencyPage from '../setting/devise/DevisePage';
import ListCommunePage from '../setting/localities/commune/list-commune/list-commune';
import listCountry from '../setting/localities/country/list-country/list-country';
import listDepartement from '../setting/localities/departement/list-departement/list-departement';
import ListRegionPage from '../setting/localities/region/list-region/list-region';
import listVillage from '../setting/localities/village/list-village/list-village';
import ListNatureCharge from '../setting/nature-charge/list-nature-charge/list-nature-charge';
import ListNatureProduct from '../setting/natureproduct/list-nature-product/list-nature-product';
import PracticePage from '../setting/technique/PracticePage';
import ListUnit from '../setting/unit/list-unit/list-unit';
import DetailTpePage from '../tpe-page/detail-tpe/detail-tpe-page';
import EditTpePage from '../tpe-page/edit-tpe/edit-tpe-page';
import ListTpePage from '../tpe-page/list-tpe/list-tpe-page';


export const routes: Route[] = [
  {
    path: '/',
    children: [
      { path: '', Component: ListProjectPage, exact: true, roles: ['ROLE_AGRISED_ADMIN', 'ROLE_AGRISED_ADMIN_SUPER'] },
    ],
  },
  {
    path: '/project/add',
    Component: CreateProjectPage,
    exact: true,
    roles: ['ROLE_AGRISED_ADMIN', 'ROLE_AGRISED_ADMIN_SUPER'],
  },
  {
    path: '/project/list',
    Component: ListProjectPage,
    exact: true,
    roles: ['ROLE_AGRISED_ADMIN', 'ROLE_AGRISED_ADMIN_SUPER'],
  },
  {
    path: '/project/detail/:id',
    Component: DetailProjectPage,
    exact: true,
    roles: ['ROLE_AGRISED_ADMIN', 'ROLE_AGRISED_ADMIN_SUPER'],
  },
  {
    path: '/project/edit/:id',
    Component: EditProjectPage,
    exact: true,
    roles: ['ROLE_AGRISED_ADMIN', 'ROLE_AGRISED_ADMIN_SUPER'],
  },
  {
    path: '/tpe/list',
    Component: ListTpePage,
    exact: true,
    roles: ['ROLE_AGRISED_ADMIN', 'ROLE_AGRISED_ADMIN_SUPER'],
  },
  {
  path: '/tpe/edit/:id',
  Component: EditTpePage,
  exact: true,
  roles: ['ROLE_AGRISED_ADMIN', 'ROLE_AGRISED_ADMIN_SUPER'],
},
  {
    path: '/tpe/detail/:id',
    Component: DetailTpePage,
    exact: true,
    roles: ['ROLE_AGRISED_ADMIN', 'ROLE_AGRISED_ADMIN_SUPER'],
  },
  { path: '/settings/locality/country', Component: listCountry, exact: true, roles: ['ROLE_AGRISED_ADMIN_SUPER'] },
  { path: '/settings/locality/region', Component: ListRegionPage, exact: true, roles: ['ROLE_AGRISED_ADMIN_SUPER'] },
  {
    path: '/settings/locality/departement',
    Component: listDepartement,
    exact: true,
    roles: ['ROLE_AGRISED_ADMIN_SUPER'],
  },
  { path: '/settings/locality/commune', Component: ListCommunePage, exact: true, roles: ['ROLE_AGRISED_ADMIN_SUPER'] },
  { path: '/settings/locality/village', Component: listVillage, exact: true, roles: ['ROLE_AGRISED_ADMIN_SUPER'] },
  { path: '/settings/activity', Component: ListActivityPage, exact: true, roles: ['ROLE_AGRISED_ADMIN'] },
  { path: '/settings/sub-activity', Component: ListSousActivity, exact: true, roles: ['ROLE_AGRISED_ADMIN'] },
  { path: '/settings/production', Component: ListProductionPage, exact: true, roles: ['ROLE_AGRISED_ADMIN'] },
  { path: '/settings/production-cycle', Component: ProductionCyclePage, exact: true, roles: ['ROLE_AGRISED_ADMIN'] },
  {
    path: '/settings/production-cycle/edit/:id',
    Component: ProductionCycleEdit,
    exact: true,
    roles: ['ROLE_AGRISED_ADMIN'],
  },
  {
    path: '/settings/production-cycle/:id',
    Component: ProductionCycleDetail,
    exact: true,
    roles: ['ROLE_AGRISED_ADMIN'],
  },
  { path: '/settings/unit', Component: ListUnit, exact: true, roles: ['ROLE_AGRISED_ADMIN'] },
  { path: '/settings/nature-charge', Component: ListNatureCharge, exact: true, roles: ['ROLE_AGRISED_ADMIN'] },
  { path: '/settings/nature-product', Component: ListNatureProduct, exact: true, roles: ['ROLE_AGRISED_ADMIN'] },
  { path: '/settings/currency', Component: CurrencyPage, exact: true, roles: ['ROLE_AGRISED_ADMIN'] },
  {
    path: '/export',
    Component: ExportConfirmationModal,
    exact: true,
    roles: ['ROLE_AGRISED_ADMIN', 'ROLE_AGRISED_ADMIN_SUPER'],
  },
  { path: '/settings/practice', Component: PracticePage, exact: true, roles: ['ROLE_AGRISED_ADMIN_SUPER'] },
  { path: '/mentions-legales', Component: MentionsLegalesPage, exact: true },

  // { path: "/settings/activity", Component: ListActivityPage, exact: true, roles: ["ROLE_AGRISED_ADMIN", "ROLE_AGRISED_ADMIN_SUPER"] },

  // { path: "/settings/sub-activity", Component: ListSousActivity, exact: true, roles: ["ROLE_AGRISED_ADMIN", "ROLE_AGRISED_ADMIN_SUPER"] },

  // { path: "/settings/production", Component: ListProductionPage, exact: true, roles: ["ROLE_AGRISED_ADMIN", "ROLE_AGRISED_ADMIN_SUPER"] },

  // { path: "/settings/unit", Component: ListUnit, exact: true, roles: ["ROLE_AGRISED_ADMIN", "ROLE_AGRISED_ADMIN_SUPER"] },

  // { path: "/settings/nature-charge", Component: ListNatureCharge, exact: true, roles: ["ROLE_AGRISED_ADMIN", "ROLE_AGRISED_ADMIN_SUPER"] },

  // { path: "/settings/nature-product", Component: ListNatureProduct, exact: true, roles: ["ROLE_AGRISED_ADMIN", "ROLE_AGRISED_ADMIN_SUPER"] },

  // { path: "/settings/locality", Component: ListLocality, exact: true, roles: ["ROLE_AGRISED_ADMIN", "ROLE_AGRISED_ADMIN_SUPER"] },
  // { path: "/settings/type-locality", Component: ListTypeLocality, exact: true, roles: ["ROLE_AGRISED_ADMIN", "ROLE_AGRISED_ADMIN_SUPER"] },
];
